export default __webpack_public_path__ + "static/Gotham-BookItalic-66fde9a4f15e0cf1f824b3a620d9bfcb.woff";